import { API } from "aws-amplify";
import { getParcel } from "~/graphql/queries";
import { LoaderData } from "~/types";
import * as APITypes from "~/API";

export const EMPTY_PARCEL: APITypes.Parcel = {
  __typename: "Parcel",
  id: "",
  propertyID: "",
  status: APITypes.ParcelStatusType.None,
  name: "",
  createdAt: "",
  updatedAt: "",
  _version: 0,
  _lastChangedAt: 0,
};

export const getParcelDetails = async (
  parcelID: string,
): Promise<LoaderData<APITypes.Parcel>> => {
  try {
    const response = (await API.graphql({
      query: getParcel,
      variables: {
        id: parcelID,
      },
    })) as { data?: APITypes.GetParcelQuery };

    if (response.data?.getParcel === null) {
      throw new Error("no parcel found");
    }

    return {
      success: true,
      data: response.data?.getParcel || EMPTY_PARCEL,
    };
  } catch (error) {
    return {
      success: false,
      data: EMPTY_PARCEL,
      error,
    };
  }
};
